'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _branch = require('recompose/branch');

var _branch2 = _interopRequireDefault(_branch);

var _withPropsOnChange = require('recompose/withPropsOnChange');

var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);

var _withHandlers = require('recompose/withHandlers');

var _withHandlers2 = _interopRequireDefault(_withHandlers);

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _consumeProps = require('recompose-scope/consumeProps');

var _consumeProps2 = _interopRequireDefault(_consumeProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _flattenDefaultProp = require('coact-utils/flattenDefaultProp');

var _flattenDefaultProp2 = _interopRequireDefault(_flattenDefaultProp);

var _pipe = require('lodash/fp/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _makeFormatter = require('../../../utils/makeFormatter');

var _makeFormatter2 = _interopRequireDefault(_makeFormatter);

var _mapPropsToFormatterSpec = require('../../../utils/makeFormatter/mapPropsToFormatterSpec');

var _mapPropsToFormatterSpec2 = _interopRequireDefault(_mapPropsToFormatterSpec);

var _validateValue = require('../enhancers/validateValue');

var _validateValue2 = _interopRequireDefault(_validateValue);

var _autoFocusWhenLoaded = require('../enhancers/autoFocusWhenLoaded');

var _autoFocusWhenLoaded2 = _interopRequireDefault(_autoFocusWhenLoaded);

var _RadioSelect = require('./RadioSelect');

var _RadioSelect2 = _interopRequireDefault(_RadioSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var enhancer = (0, _composeWithScope2.default)((0, _consumeProps2.default)({
  value: _propTypes.any,
  onChange: _propTypes.func.isRequired,
  schema: _propTypes.object,
  block: _propTypes.object,
  formatter: _propTypes.func
}), (0, _flattenDefaultProp2.default)('block'), (0, _flattenDefaultProp2.default)('schema'), (0, _branch2.default)(function (_ref) {
  var formatter = _ref.formatter;
  return !formatter;
}, (0, _withPropsOnChange2.default)(_mapPropsToFormatterSpec2.default.isEqualSpec, function (props) {
  return {
    formatter: (0, _pipe2.default)(_mapPropsToFormatterSpec2.default, _makeFormatter2.default)(props)
  };
})), (0, _withPropsOnChange2.default)(['formatter'], function (_ref2) {
  var formatter = _ref2.formatter;
  return {
    optionAdapter: function optionAdapter(option) {
      return {
        value: option,
        label: formatter(option)
      };
    }
  };
}), (0, _withPropsOnChange2.default)(['options', 'optionAdapter'], function (_ref3) {
  var options = _ref3.options,
      optionAdapter = _ref3.optionAdapter;
  return {
    options: options.map(optionAdapter)
  };
}), (0, _withHandlers2.default)({
  onChange: function onChange(_ref4) {
    var _onChange = _ref4.onChange;
    return function (event) {
      return _onChange(event.target.value);
    };
  }
}), _validateValue2.default, _autoFocusWhenLoaded2.default, (0, _exposeProps2.default)(['value', 'name', 'disabled', 'options', 'onChange', 'isInvalid', 'inputRef']));

var RadioSelect = enhancer(_RadioSelect2.default);
RadioSelect.displayName = 'RadioSelect';

exports.default = RadioSelect;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/RadioSelect/index.js
// module id = 1774
// module chunks = 0